import { render, staticRenderFns } from "./classRecord.vue?vue&type=template&id=5fc2dd7c&scoped=true"
import script from "./classRecord.vue?vue&type=script&lang=js"
export * from "./classRecord.vue?vue&type=script&lang=js"
import style0 from "./classRecord.vue?vue&type=style&index=0&id=5fc2dd7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2dd7c",
  null
  
)

export default component.exports